module.exports = __webpack_public_path__ + "img/title1.559d99fa.png";